import { environment } from '../../../environments/environment';

export function isAnalyticsEnabled(): boolean {
  // Sin `measurementId` no hay a dónde enviar: `getAnalytics()` no puede resolver la
  // configuración y falla en tiempo de ejecución. El entorno de pruebas arranca así, sin
  // propiedad de GA4 enlazada, y se enciende solo en cuanto se pegue el id.
  if (!environment.firebase.measurementId) {
    return false;
  }
  // Pruebas tiene su propio stream de GA4 (viene con el proyecto Firebase aparte), así
  // que sus eventos no contaminan las métricas de producción.
  return environment.envName !== 'development' || environment.useAnalyticsInDev === true;
}
